import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format, parseISO, parse } from 'date-fns';
import { ChevronRight, Calendar } from 'lucide-react';
import type { UpcomingBooking } from '../../../hooks/useUpcomingBookings';
import { useDateLocale } from '../../../hooks/useDateLocale';
import './UpcomingBookingCard.css';

interface Props {
  booking: UpcomingBooking;
}

const UpcomingBookingCard: React.FC<Props> = ({ booking }) => {
  const navigate = useNavigate();
  const { dateFnsLocale } = useDateLocale();

  const formatBookingDate = (item: UpcomingBooking): string => {
    try {
      const date = item.startDateTime
        ? parseISO(item.startDateTime)
        : parse(`${item.date} ${item.startTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
      return format(date, 'EEE d MMM, HH:mm', { locale: dateFnsLocale });
    } catch {
      return item.date;
    }
  };

  return (
    <button
      className="upcoming-booking-card"
      onClick={() => navigate(`/reservations?booking_id=${booking.bookingId}`)}
    >
      <div className="upcoming-booking-card__icon">
        <Calendar size={20} />
      </div>
      <div className="upcoming-booking-card__body">
        <p className="upcoming-booking-card__pro">{booking.pro.name}</p>
        <p className="upcoming-booking-card__meta">
          {booking.service.serviceName}
          {booking.animal?.name ? ` · ${booking.animal.name}` : ''}
        </p>
        <p className="upcoming-booking-card__date">{formatBookingDate(booking)}</p>
      </div>
      <ChevronRight size={16} className="upcoming-booking-card__chevron" />
    </button>
  );
};

export default UpcomingBookingCard;
